export interface ShopType {
  id: string;
  title: string;
  description?: string;
  type: SHOP_TYPE;
  imageLink: string;
  videoLink?: string;
  ctaText?: string;
  ctaLink?: string;
  status?: string;
  sortOrder?: number;
  countries?: string;
  options?: any;
}

export interface FormShopType {
  title: string;
  description?: string;
  type: SHOP_TYPE;
  imageLink: string;
  videoLink?: string;
  ctaText?: string;
  ctaLink?: string;
  sortOrder?: number;
  countries?: string;
  options?: any;
}

export enum SHOP_TYPE {
  PRODUCT_TILES = 'PRODUCT_TILES',
  MORE_FOR_YOU = 'MORE_FOR_YOU',
  MAINSTAYS = 'SUPPORT_CARD',
  FINAL_TILE = 'FINAL_TILE',
  PROMOTION = 'PROMOTION',
  THE_DAILY = 'THE_DAILY',
  PLAYER_PROFILE = 'PLAYER_PROFILE',
  JUST_IN_CLUBHOUSE = 'JUST_IN_CLUBHOUSE',
}

export enum ShopStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum LinkType {
  WEB_LINK = 'WEB_LINK',
  DEEP_LINK = 'DEEP_LINK',
  CMS = 'CMS',
}

export interface SetDisabledTypePrams {
  disabled: boolean;
}

export interface SortShopsPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
  }[];
}

export const LinkTypeList = [
  {
    text: 'Link/URL',
    value: LinkType.WEB_LINK,
  },
  {
    text: 'CMS',
    value: LinkType.CMS,
  },
  {
    text: 'App Deeplink',
    value: LinkType.DEEP_LINK,
  },
];

export const LinkTypeListNotCMS = [
  {
    text: 'Link/URL',
    value: LinkType.WEB_LINK,
  },
  {
    text: 'App Deeplink',
    value: LinkType.DEEP_LINK,
  },
];
